import userTypes from './user.types';

export const setCurrentUser = (user) => ({
  type: userTypes.SET_CURRENT_USER,
  payload: user,
});

export const loginUserStart = (payload) => ({
  type: userTypes.LOGIN_USER_START,
  payload,
});

export const autoLoginUserStart = (payload) => ({
  type: userTypes.AUTO_LOGIN_USER_START,
  payload,
});

export const logoutUserStart = (history) => ({
  type: userTypes.LOGOUT_USER_START,
  payload: history,
});

export const resetPasswordStart = (payload) => ({
  type: userTypes.RESET_PASSWORD_START,
  payload,
});

export const signupStart = (payload) => ({
  type: userTypes.SIGNUP_START,
  payload,
});

export const verifyUserCredentialsStart = (userCredentials) => ({
  type: userTypes.VERIFY_USER_CREDENTIALS_START,
  payload: userCredentials,
});

export const validateSmsVerificationCodeStart = ({
  mobile,
  verificationCode,
  setError,
  onSuccess,
}) => ({
  type: userTypes.VALIDATE_SMS_VERIFICATION_CODE_START,
  payload: { mobile, verificationCode, setError, onSuccess },
});

export const sendVerificationSmsAction = ({ mobile, onSuccess }) => ({
  type: userTypes.SEND_VERIFICATION_SMS,
  payload: { mobile, onSuccess },
});

export const resendVerificationSmsStart = (mobile) => ({
  type: userTypes.RESEND_VERIFICATION_SMS_START,
  payload: mobile,
});

export const validateSmsAndRedirectToPaymentStart = (invoice) => ({
  type: userTypes.VALIDATE_SMS_AND_REDIRECT_TO_PAYMENT_START,
  payload: invoice,
});

export const resetStoreDataStart = () => ({
  type: userTypes.RESET_STORE_DATA,
});

// POST REQUEST FOR TWO-STEP VERIFICATION
export const postUserDataForOTV = (data) => ({
  type: userTypes.POST_USER_DATA_OF_OTV,
  payload: data,
});

export const postUserDataForOTVSuccess = (data) => ({
  type: userTypes.POST_USER_DATA_OF_OTV_SUCCESS,
  payload: data,
});

export const postUserDataForOTVFailure = (error) => ({
  type: userTypes.POST_USER_DATA_OF_OTV_FAILURE,
  payload: error,
});

export const loginUserOneTimeCodeStart = (payload) => ({
  type: userTypes.LOGIN_USER_ONE_TIME_CODE,
  payload,
});
